import { DyTableColumn } from '@dynamics/model/dy-model';

export const TABLE_CONFIG_COLUMNS_FAILED_PAYMENT: DyTableColumn[] = [
  // {
  //   dataKey: 'actions',
  //   label: 'Actions',
  //   width: 150,
  //   type: 'action',
  //   actions: [
  //     {
  //       name: 'print',
  //       iconName: 'print',
  //     },
  //     {
  //       name: 'email',
  //       iconName: 'email',
  //     },
  //   ],
  // },
  {
    dataKey: 'fixIt',
    label: 'Fix It',
    width: 200,
    type: 'action',
    actions: [
      {
        name: 'fix-it',
        text: 'Fix It',
      },
    ],
    alignClass: 'text-center',
  },
  { dataKey: 'id', label: 'ID', width: 100, type: 'text' },
  // { dataKey: 'invNo', label: 'Invoice Number', width: 150, type: 'text' },
  {
    dataKey: 'transactionId',
    label: 'Transaction ID',
    width: 150,
    type: 'number',
  },
  // {
  //   dataKey: 'receiptId',
  //   label: 'Receipt ID',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'createDate',
    label: 'Payment Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'paymentMode',
    label: 'Payment Mode',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'cardTypeNumber',
    label: 'Card Type Number',
    width: 200,
    type: 'text',
  },
  // {
  //   dataKey: 'failAge',
  //   label: 'Fail Age',
  //   width: 100,
  //   type: 'number',
  // },
  {
    dataKey: 'displayMessage',
    label: 'Transaction Status',
    width: 150,
    type: 'status',
  },
];

// export const FAILED_PAYMENT_STATUS_DROPDOWN: any[] = [
//   {
//     value: 1,
//     name: 'Declined',
//   },
//   {
//     value: 2,
//     name: 'Will be Declined',
//   },
// ];
